import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { arrayMove } from 'react-sortable-hoc';

import * as API from '../../webAPI/MKSService';
import { getLockingsRequest, moveLockingRequest } from './lockingsActions';
import { getLockings } from '../../reducers/lockings';
import {
	getActiveLockingId,
	doToggleActiveLockingId
} from '../../reducers/app/activeLockingId';

import LockingsList from './LockingsList';

import buildTree from './tree';

class LockingsListContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lockingsTree: props.lockingsTree
		};

		this.handleClick = this.handleClick.bind(this);
		this.handleSortEnd = this.handleSortEnd.bind(this);
	}

	componentDidMount() {
		this.props.getLockingsRequest();
	}

	componentWillReceiveProps(nextProps) {
		const { lockingsTree } = nextProps;
		this.setState({ lockingsTree });
	}

	render() {
		const { activeLockingId, toggleActiveLocking } = this.props;
		const { lockingsTree } = this.state;

		const sortableProps = {
			lockAxis: 'y',
			useDragHandle: true,
			onSortEnd: this.handleSortEnd
		};

		return (
			<LockingsList
				activeLockingId={activeLockingId}
				lockings={lockingsTree.children}
				onClick={this.handleClick}
				{...sortableProps}
			/>
		);
	}

	handleClick(lockingId) {
		const { activeLockingId, toggleActiveLockingId } = this.props;

		const isActive = lockingId === activeLockingId;

		if (isActive) {
			toggleActiveLockingId();
		} else {
			toggleActiveLockingId(lockingId);
		}
	}

	handleSortEnd({ oldIndex, newIndex, collection }) {
		const { lockingsTree } = this.state;

		const lockingsTreeCopy = { ...lockingsTree };

		const isInGroup = collection;

		const subTree = isInGroup
			? lockingsTreeCopy.children.find(
					locking => locking.locking_id === collection
				)
			: lockingsTreeCopy;

		subTree.children = arrayMove(subTree.children, oldIndex, newIndex);

		this.setState({ lockingsTree: lockingsTreeCopy });

		const parentLockingId = subTree.locking_id;
		const previousLocking = subTree.children[newIndex - 1];
		const afterLockingId = previousLocking
			? previousLocking.locking_id
			: subTree.locking_id;
		const locking = subTree.children[newIndex];

		this.props.moveLockingRequest(locking, parentLockingId, afterLockingId);
	}

	/*
  moveLockingRequest(locking, parentLockingId, afterLockingId) {
    const { projectId } = this.props.params;
    API.moveLocking(projectId, parentLockingId, afterLockingId, locking).then(
      () => null,
      results => {
        const lockingsTree = buildTree(results);
        console.log('lockingsTree', lockingsTree);
        this.setState({ lockingsTree });
      }
    );
  }
  */
}

function mapStateToProps(state) {
	const lockings = getLockings(state);
	const lockingsTree = buildTree(lockings);
	return {
		activeLockingId: getActiveLockingId(state),
		lockingsTree
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		toggleActiveLockingId: locking => {
			dispatch(doToggleActiveLockingId(locking));
		},
		getLockingsRequest: () => dispatch(getLockingsRequest(projectId)),
		moveLockingRequest: (locking, parentLockingId, afterLockingId) =>
			dispatch(
				moveLockingRequest(
					projectId,
					locking,
					parentLockingId,
					afterLockingId
				)
			)
	};
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(LockingsListContainer)
);



// WEBPACK FOOTER //
// ./src/js/plan/lockings/LockingsListContainer.js